<template>
<div>
    <div class="payment-methods">
        <a class="" @click="changeComponent(item.auth_type, key)" v-for="(item, key) in initialItems" :key="key">
            <div class="method">
                <img :src="item.image_url" :alt="item.title" />
                <p class="content" v-html="item.title"></p>
            </div>
        </a>

    </div>
    <div v-if="!loading" class="text-center mt-4">
        <a href="javascript:void(0)" class="change-option" @click.prevent="reload" title="Fetch payment methods again"> &#x21bb; Refresh </a>
    </div>
</div>
</template>

<script>
export default {
    name: 'payment-options',
    props: {
        data: Object,
        client_info: Object,
        title_prefix: String,
        template: {
            type: String,
            default: 'default'
        }
    },

    computed: {
        // this.client_info.paginate_count
        option_list() {
            // show_more
            // return data.channels.slice(0, this.client_info.paginate_count || 5);
            return this.data.channels.filter((item) => {
                item.auth_type.toLowerCase() == 'card' || (item.action && item.action.length > 0)
            });
        }
    },
    data() {
        return {
            trx_otp: '',
            otp_error_message: '',
            // client_info: {},
            isFocus: true,
            focusColor: '',
            totalShown: 0,
            perPage: 0,
            halfList: [],
            showNum: true,
            hover: false,
            listHover: false,
            hoverKey: '',
            paginate_hover_in_style: {},
            paginate_hover_out_style: {},
            option_item_hover: {},
            loading: false,
            showPagination: false,
            show_more: false,
            errors: {
                trx_otp: false,
            },
            initialItems: [],
        }
    },

    async mounted() {

        try {

            this.$emit('handleTitle', 'Pay with')

            this.perPage = this.client_info.paginate_count;
            /* this.paginate_hover_out_style = '';
            this.paginate_hover_in_style = {
                background: this.client_info.colors.app,
                color: '#ffffff'
            }; */

            let key;

            this.option_item_hover = {
                background: (this.listHover && this.hoverKey == key) ? this.client_info.colors.list_hover_background + '!important' : '',
                color: (this.listHover && this.hoverKey == key) ? this.client_info.colors.list_arrow_hover || this.client_info.colors.app : this.client_info.colors.list_arrow || this.client_info.colors.app
            };

            // Check if default view is present
            if (this.$store.state.showDefaultView) {
                let defaultView = await this.$parent.hasDefaultView();
                // console.log(defaultView);
                if (defaultView.status) {
                    this.changeComponent(defaultView.auth_type, defaultView.key, true, defaultView.provider_key, );
                    return;
                }
            } else if (this.data.channels.length == 1) {
                // console.log("Channel list is just One");
                this.changeComponent(this.data.channels[0].auth_type, 0)
            } else { // halfList
                // console.log("Channel list is more than  One");
                if (this.client_info.paginate === true) {
                    this.showPagination = this.data.channels.length > this.client_info.paginate_count ? true : false;
                    this.perPage = this.client_info.paginate_count;
                    this.totalShown = this.perPage
                    // this.initialItems = this.data.channels.slice(0, this.client_info.paginate_count);
                    this.initialItems = this.data.channels;
                } else {
                    this.initialItems = this.data.channels;
                }
            }
        } catch (err) {
            console.log(err);
        }
    },

    methods: {
        hoverEffect(value, key) {
            this.listHover = value
            this.hoverKey = key
        },
        showMore() {
            // let itemList = document.getElementById('itemList');
            // height = itemList.offsetHeight;

            setTimeout(() => {
                this.initialItems = this.data.channels;
                this.totalShown = this.initialItems.length;
            }, 100)
        },
        showLess() {
            this.initialItems = this.data.channels.slice(0, this.client_info.paginate_count);
            this.totalShown = this.initialItems.length;
        },
        changeComponent(method, index, defaultView = false, provider_key = 0) {

            try {

                let data = this.data.channels[index];

                this.$store.dispatch('paymentMethod', method)
                this.$store.dispatch('paymentMethodIndex', index)
                this.$store.dispatch('paymentMethodProvider', method.toLowerCase())
                // this.$store.dispatch('provider', data);

                let componentId = "";
                // activeName = "";
                let id_name = "";
                let title = data.title || '';
                let transaction;
                let redirectData;

                // Keep Payment Option
                switch (method.toLowerCase()) {
                    case "airtime":
                        componentId = "Airtime";
                        // activeName = "Airtime";
                        id_name = "airtime";
                        break;

                    case "wallet":
                        componentId = "Airtime";
                        // activeName = "wallet";
                        break;

                    case "bank.account":
                        componentId = "Airtime";
                        id_name = "bankdebit";
                        // activeName = "account";
                        break;

                    case "voucher":
                        componentId = "Airtime";
                        // activeName = "voucher";
                        id_name = "voucher";
                        break;

                    case "bank.transfer":
                        componentId = "Transfer";
                        // activeName = "Transfer";
                        break;

                    case "cash":
                        componentId = "Transfer";
                        // activeName = "cash";
                        break;

                    case "masterpass":
                    case "ipg":
                    case "paystack":
                    case "custom":
                        
                        if (this.data.channels[index].action.length === 0) {
                            componentId = "NoProvider";
                            this.$parent.changeComponent(componentId, this.data.channels[index].action[0], id_name, title);
                        }
                        else if (this.data.channels[index].action.length === 1) {
                            let provider = this.data.channels[index].action[0].provider.toLowerCase();

                            switch (provider) { //For the New changes
                                case 'mpgs':
                                    componentId = "CardPayment";
                                    id_name = "mastercard";

                                    break;

                                case 'comingsoon':
                                    componentId = "ComingSoon";
                                    this.$parent.changeComponent(componentId, this.data.channels[index].action[0], id_name, title);
                                    return;

                                default:
                                    // Do a second level check using providers or check if the have urls then you load the urls or the relevant pages 
                                    componentId = "Redirect";
                                    id_name = "";
                                    // Build User information or data and pass as props
                                    transaction = this.$store.state.payload.transaction;
                                    redirectData = {
                                        'channels': this.data.channels,
                                        // 'details': data.action[0],
                                        'index': index,
                                        'transaction': transaction
                                    }

                                    // console.log(redirectData);

                                    if (data.action.length > 1) {
                                        if (data.action.length > 1 && defaultView) {
                                            redirectData.details = data.action[provider_key]
                                            redirectData.action = data.action;
                                            redirectData.custom_providers = data.action;
                                        } else {
                                            redirectData.action = data.action;
                                            redirectData.custom_providers = data.action;
                                        }
                                    } else {
                                        redirectData.details = data.action[0]
                                    }

                                    data = redirectData;
                                    break;
                            }
                        } else {
                            // Do a second level check using providers or check if the have urls then you load the urls or the relevant pages 
                            componentId = "Redirect";
                            // Build User information or data and pass as props
                            transaction = this.$store.state.payload.transaction
                            redirectData = {
                                'channels': this.data.channels,
                                // 'details': data.action[0],
                                'index': index,
                                'transaction': transaction
                            }

                            // console.log(redirectData);

                            if (data.action.length > 1) {
                                if (data.action.length > 1 && defaultView) {
                                    redirectData.details = data.action[provider_key]
                                    redirectData.action = data.action;
                                    redirectData.custom_providers = data.action;
                                    redirectData.action = data.action;
                                } else {
                                    redirectData.action = data.action;
                                    redirectData.custom_providers = data.action;
                                }
                            } else {
                                redirectData.details = data.action[0]
                            }
                            data = redirectData;
                        }
                        break;

                    default:
                    case "card":
                        componentId = "CardPayment";
                        id_name = "addcard";
                }

                this.$parent.changeComponent(componentId, data, id_name, title);
            } catch (err) {
                console.log(err);
            }
        },
        reload() {
            // Hit the Options api again
            this.$parent.reload();
        }
    }
};
</script>